import { useState } from 'react';
import { Box, Typography, Paper, Stack, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import type { Entry, EntryCategory } from '@lorrainemarwood-care/shared';
import { EntryCategoryLabels } from '@lorrainemarwood-care/shared';
import { api } from '../lib/api';
import EntryForm from '../components/EntryForm';
import EntryList from '../components/EntryList';

const CATEGORIES: (EntryCategory | 'all')[] = ['all', 'med', 'symptom', 'note', 'handover', 'meal', 'appointment'];

export default function Log() {
  const [filter, setFilter] = useState<EntryCategory | 'all'>('all');

  const query = useQuery({
    queryKey: ['entries', { filter }],
    queryFn: () =>
      api.get<Entry[]>(
        filter === 'all' ? '/api/entries?limit=200' : `/api/entries?category=${filter}&limit=200`,
      ),
  });

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>Log</Typography>

      <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>New entry</Typography>
        <EntryForm />
      </Paper>

      <Stack spacing={2}>
        <ToggleButtonGroup
          value={filter}
          exclusive
          onChange={(_, v) => v && setFilter(v)}
          size="small"
        >
          {CATEGORIES.map((c) => (
            <ToggleButton key={c} value={c}>
              {c === 'all' ? 'All' : EntryCategoryLabels[c]}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>

        <EntryList entries={query.data ?? []} />
      </Stack>
    </Box>
  );
}
